module.exports = __webpack_public_path__ + "static/img/loyo-medal-1.25a5c7f8.png";